"use strict";

var Ajv = require('ajv');

var activitySchema = require('./activitySchema');

var validateActivity = function validateActivity(schemaType) {
  var edgeSchema = activitySchema(schemaType);
  var ajv = Ajv({
    allErrors: true
  });
  var validate = ajv.compile(edgeSchema);
  return function (activityJson) {
    var isValid = validate(activityJson);
    if (isValid) return true;
    return ajv.errorsText(validate.errors);
  };
};

module.exports = validateActivity;